import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscribePageComponent } from './components/pages/subscribe-page/subscribe-page.component';
import { ConfirmationPageComponent } from './components/pages/confirmation-page/confirmation-page.component';
import { ErrorPageComponent } from './components/pages/error-page/error-page.component';


export const ROUTE_NAMES ={
  CONFIRMATION: 'confirmation',
  ERROR: 'error',
};

const routes: Routes = [  
  {
    path:'',
    component: SubscribePageComponent,
    pathMatch: 'full'
  },
  {
    path: ROUTE_NAMES.CONFIRMATION,
    component: ConfirmationPageComponent,
    pathMatch: 'full'
  },  
  {
    path: ROUTE_NAMES.ERROR,
    component: ErrorPageComponent,
    pathMatch: 'full'
  },    
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
